import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  userInfo: {},
  existingUserInfo: {},
  existingAddressInfo: {},
  addressInfo: {},
  passwordInfo: { password1: '', password2: '' },
};

export const userInfoSlice = createSlice({
  name: 'userInfo',
  initialState,
  reducers: {
    updateUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    updateExistingUserInfo: (state, action) => {
      state.existingUserInfo = action.payload;
    },
    updateExistingAddressInfo: (state, action) => {
      state.existingAddressInfo = action.payload;
    },
    protectUserInfo: (state) => {
      state.userInfo = state.existingUserInfo;
    },
    updateUserInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.userInfo[field] = value;
    },
    updateAddressInfo: (state, action) => {
      state.addressInfo = action.payload;
    },
    protectAddressInfo: (state) => {
      state.addressInfo = state.existingAddressInfo;
    },
    updateAddressInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.addressInfo[field] = value;
    },
    updatePasswordInfoField: (state, action) => {
      const { field, value } = action.payload;
      state.passwordInfo[field] = value;
    },
    resetPasswordInfo: (state) => {
      state.passwordInfo = initialState.passwordInfo;
    },
  },
});

export const userInfoSelector = (state) => state.userInfo.userInfo;
export const userCustomerIdSelector = (state) =>
  state.userInfo.userInfo.customerId;
export const addressInfoSelector = (state) => state.userInfo.addressInfo;
export const passwordInfoSelector = (state) => state.userInfo.passwordInfo;
export const {
  updateUserInfo,
  updateExistingUserInfo,
  updateExistingAddressInfo,
  updateUserInfoField,
  updateAddressInfo,
  updatePasswordInfoField,
  resetPasswordInfo,
  updateAddressInfoField,
  protectUserInfo,
  protectAddressInfo,
} = userInfoSlice.actions;

export const userInfoReducer = userInfoSlice.reducer;
export const userInfoReducerName = userInfoSlice.name;

export default userInfoSlice.reducer;
